/* eslint-disable import/prefer-default-export */
import { TranslationContactUsMessages, ContactUsMessages } from "../interfaces";

export const messages: TranslationContactUsMessages = {
  [ContactUsMessages.developedBy]: "TopconFLEET is developed by",
  [ContactUsMessages.topcon]: "Topcon - The Concrete Company.",
  [ContactUsMessages.allRightsReserved]: "All rights reserved"
};
